import { type ReactNode } from "react";
import { Navigate, Outlet } from "react-router-dom";

import { ROUTES } from "~/router/routes";
import { useSignUpStore } from "~/stores";

export const ProtectedOnboardingRoute = ({
  children,
}: {
  children?: ReactNode;
}) => {
  const { hasRequiredPatientFields } = useSignUpStore();

  if (!hasRequiredPatientFields()) {
    return <Navigate to={ROUTES.signUp} replace />;
  }

  return children ? <>{children}</> : <Outlet />;
};
